(function(){
    document.querySelectorAll('.lvnt-particles-block').forEach(function(root){
      if (root.dataset.lvntInit) return;
      root.dataset.lvntInit = '1';

      const canvas = root.querySelector('.lvnt-canvas');
      const ctx = canvas.getContext('2d');
      const srcImg = root.querySelector('.lvnt-src');
      const DPR = Math.min(window.devicePixelRatio || 1, 2);

      let W, H;
      let particles = [];
      let mouse = { x: -9999, y: -9999, active: false };
      let scrollProgress = 0;
      let imgReady = false;
      let expanded = false;

      const SAMPLE_STEP = 6.2;
      const DARK_THRESHOLD = 200;
      const DOT_RADIUS = 1.4;
      const SPRING = 0.86;
      const SPRING_EXPANDED = 0.12;
      const FRICTION = 0.26;

      const IDLE_AMPLITUDE = 6;
      const IDLE_SPEED = 0.0015;
      const FOLLOW_STRENGTH = 0.06;

      const HOVER_RADIUS = 150;
      const HOVER_FORCE = 4.5;

      const EXPANDED_COUNT = 70;
      const EXPANDED_SIZES = [1.4, 2.6, 4];

      function resize(){
        const rect = root.getBoundingClientRect();
        W = rect.width;
        H = rect.height;
        canvas.width = W * DPR;
        canvas.height = H * DPR;
        canvas.style.width = W + 'px';
        canvas.style.height = H + 'px';
        ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
        if (imgReady){
          buildParticles();
          if (expanded) assignRandomTargets();
        }
      }

      function buildParticles(){
        const isMobile = W < 700;
        const sampleStep = isMobile ? 3.4 : SAMPLE_STEP;
        const dotRadius = isMobile ? 1.1 : DOT_RADIUS;

        const off = document.createElement('canvas');
        const octx = off.getContext('2d');
        off.width = W;
        off.height = H;
        octx.clearRect(0, 0, W, H);

        const iw = srcImg.naturalWidth;
        const ih = srcImg.naturalHeight;
        const maxW = W * (isMobile ? 0.92 : 0.7);
        const maxH = H * (isMobile ? 0.5 : 0.42);
        const scale = Math.min(maxW / iw, maxH / ih);
        const dw = iw * scale;
        const dh = ih * scale;
        const dx = (W - dw) / 2;
        const dy = (H - dh) / 2;

        octx.drawImage(srcImg, dx, dy, dw, dh);
        const imgData = octx.getImageData(0, 0, W, H).data;

        const pts = [];
        for (let y = dy; y < dy + dh; y += sampleStep){
          for (let x = dx; x < dx + dw; x += sampleStep){
            const idx = ((y | 0) * W + (x | 0)) * 4;
            const r = imgData[idx], g = imgData[idx + 1], b = imgData[idx + 2], a = imgData[idx + 3];
            if (a > 100 && (r + g + b) < DARK_THRESHOLD){
              const jx = x + (Math.random() - 0.5) * sampleStep * 0.25;
              const jy = y + (Math.random() - 0.5) * sampleStep * 0.25;
              pts.push(jx, jy);
            }
          }
        }

        const cx = W / 2, cy = H / 2;
        particles = [];
        for (let i = 0; i < pts.length; i += 2){
          const hx = pts[i], hy = pts[i + 1];
          const angle = Math.atan2(hy - cy, hx - cx);
          particles.push({
            hx, hy,
            rx: hx, ry: hy,
            x: hx, y: hy,
            vx: 0, vy: 0,
            angle,
            r: dotRadius,
            expandedR: dotRadius,
            expandedVisible: false,
            phase: Math.random() * Math.PI * 2
          });
        }
      }

      function assignRandomTargets(){
        const total = particles.length;
        if (!total) return;

        const indices = particles.map((_, i) => i);
        for (let i = indices.length - 1; i > 0; i--){
          const j = Math.floor(Math.random() * (i + 1));
          [indices[i], indices[j]] = [indices[j], indices[i]];
        }

        const count = Math.min(EXPANDED_COUNT, total);
        const selected = indices.slice(0, count);
        const selectedSet = new Set(selected);

        particles.forEach((p, i) => {
          p.expandedVisible = selectedSet.has(i);
        });

        const cols = Math.max(1, Math.round(Math.sqrt(count * (W / H))));
        const rows = Math.max(1, Math.ceil(count / cols));
        const cellW = W / cols;
        const cellH = H / rows;

        const cells = [];
        for (let i = 0; i < cols * rows; i++) cells.push(i);
        for (let i = cells.length - 1; i > 0; i--){
          const j = Math.floor(Math.random() * (i + 1));
          [cells[i], cells[j]] = [cells[j], cells[i]];
        }

        selected.forEach((particleIndex, i) => {
          const p = particles[particleIndex];
          const cell = cells[i % cells.length];
          const col = cell % cols;
          const row = Math.floor(cell / cols);
          p.rx = col * cellW + cellW * 0.5 + (Math.random() - 0.5) * cellW * 0.7;
          p.ry = row * cellH + cellH * 0.5 + (Math.random() - 0.5) * cellH * 0.7;
          p.expandedR = EXPANDED_SIZES[Math.floor(Math.random() * EXPANDED_SIZES.length)];
        });
      }

      function onMouseMove(e){
        const rect = root.getBoundingClientRect();
        mouse.x = e.clientX - rect.left;
        mouse.y = e.clientY - rect.top;
        mouse.active = true;
      }
      function onMouseLeave(){ mouse.active = false; }
      function onTouchMove(e){
        if (e.touches && e.touches[0]){
          const rect = root.getBoundingClientRect();
          mouse.x = e.touches[0].clientX - rect.left;
          mouse.y = e.touches[0].clientY - rect.top;
          mouse.active = true;
        }
      }

      function updateScrollProgress(){
        const rect = root.getBoundingClientRect();
        scrollProgress = Math.min(1, Math.max(0, -rect.top / rect.height));
      }

      function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

      function tick(){
        updateScrollProgress();
        if (imgReady){
          ctx.clearRect(0, 0, W, H);
          ctx.fillStyle = getComputedStyle(root).getPropertyValue('--lvnt-dot').trim() || '#242b23';

          const t = performance.now();
          const scrollExplode = easeOutCubic(scrollProgress) * Math.max(W, H) * 0.9;

          let mouseOffsetX = 0, mouseOffsetY = 0;
          if (mouse.active){
            mouseOffsetX = (mouse.x - W / 2) * FOLLOW_STRENGTH;
            mouseOffsetY = (mouse.y - H / 2) * FOLLOW_STRENGTH;
          }

          for (let i = 0; i < particles.length; i++){
            const p = particles[i];

            if (expanded && !p.expandedVisible) continue;

            const baseX = expanded ? p.rx : (p.hx + Math.cos(p.angle) * scrollExplode);
            const baseY = expanded ? p.ry : (p.hy + Math.sin(p.angle) * scrollExplode);

            const idleX = Math.cos(t * IDLE_SPEED + p.phase) * IDLE_AMPLITUDE;
            const idleY = Math.sin(t * IDLE_SPEED * 1.3 + p.phase) * IDLE_AMPLITUDE;

            const targetX = baseX + idleX + mouseOffsetX;
            const targetY = baseY + idleY + mouseOffsetY;

            const spring = expanded ? SPRING_EXPANDED : SPRING;
            let ax = (targetX - p.x) * spring;
            let ay = (targetY - p.y) * spring;

            if (mouse.active){
              const dx = p.x - mouse.x;
              const dy = p.y - mouse.y;
              const d = Math.hypot(dx, dy);
              if (d < HOVER_RADIUS && d > 0.001){
                const force = (1 - d / HOVER_RADIUS) * HOVER_RADIUS * HOVER_FORCE * 0.06;
                ax += (dx / d) * force;
                ay += (dy / d) * force;
              }
            }

            p.vx = (p.vx + ax) * FRICTION;
            p.vy = (p.vy + ay) * FRICTION;
            p.x += p.vx;
            p.y += p.vy;

            const fade = expanded ? 1 : (1 - Math.min(1, scrollProgress * 0.7));
            ctx.globalAlpha = fade;
            ctx.beginPath();
            ctx.arc(p.x, p.y, expanded ? p.expandedR : p.r, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.globalAlpha = 1;
        }
        requestAnimationFrame(tick);
      }

      window.addEventListener('resize', resize);
      root.addEventListener('mousemove', onMouseMove);
      root.addEventListener('mouseleave', onMouseLeave);
      root.addEventListener('touchmove', onTouchMove, { passive: true });
      root.addEventListener('click', function(){
        expanded = !expanded;
        if (expanded) assignRandomTargets();
      });

      function start(){
        imgReady = true;
        resize();
        updateScrollProgress();
        requestAnimationFrame(tick);
      }

      if (srcImg.complete && srcImg.naturalWidth > 0){
        start();
      } else {
        srcImg.addEventListener('load', start);
      }
    });
  })();